import './styes/Footer.css';
import { useState } from 'react';

const Footer = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupPos, setPopupPos] = useState<{x:number,y:number}|null>(null);

  const handleServiceClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const rect = (e.target as HTMLElement).getBoundingClientRect();
    setPopupPos({ x: rect.left + rect.width / 2, y: rect.top });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 1800);
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="logo-container">
            <img src="/images/logo-nobg.png" alt="BuildZap Logo" className="footer-logo" />
          </div>
          <h3 className="section-title">BuildZap</h3>
          <ul className="footer-links">
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/refund">Refund Policy</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="section-title">Products</h3>
          <div className="products-columns">
            <ul className="footer-links">
              <li><a href="/view-products/sanitary-bath-fittings">Sanitary & Bath</a></li>
              <li><a href="/view-products/water-proofing">Water Proofing</a></li>
              <li><a href="/view-products/electricals">Electricals</a></li>
              <li><a href="/view-products/pain">Paints</a></li>
              <li><a href="/view-products/building-materials">Building Materials</a></li>
              <li><a href="/categories/view-all">View All</a></li>
            </ul>
            <ul className="footer-links">

            </ul>
          </div>
        </div>

        {/* Services Section */}
        <div className="footer-section">
          <h3 className="section-title">Services</h3>
          <ul className="footer-links">
            <li><a href="/services/plumber" onClick={handleServiceClick}>Plumber</a></li>
            <li><a href="/services/carpenter" onClick={handleServiceClick}>Carpenter</a></li>
            <li><a href="/services/electrician" onClick={handleServiceClick}>Electrician</a></li>
            <li><a href="/services/painter" onClick={handleServiceClick}>Painter</a></li>
            <li><a href="/services/plumber-2" onClick={handleServiceClick}>Plumber</a></li>
            <li><a href="/services/mason" onClick={handleServiceClick}>Mason</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h3 className="section-title">Contact Us</h3>
          <div className="contact-info">
            <p>Suncity, Sector 54, Gurugram,</p>
            <p>Haryana, India</p>
            <p className="phone">
              <a href="tel:+917617610660">(+91) 761-761-0660</a>
            </p>
            <p className="email">
              <a href="mailto:hi@buildzap.in">hi@buildzap.in</a>
            </p>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>BuildZap is owned and operated by BSC INNOVATIONS PVT LTD</p>
      </div>
      {showPopup && popupPos && (
        <div 
          style={{
            position: 'fixed',
            left: popupPos.x,
            top: popupPos.y - 30,
            transform: 'translateX(-50%)',
            background: '#333',
            color: '#fff',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            zIndex: 1000
          }}
          aria-live="polite"
          role="status"
        >
          Coming very soon!!
        </div>
      )}
    </footer>
  );
};

export default Footer;